import type { FC } from 'react'
import React from 'react'
import { JournalSearchInput, RubricsMenu } from '@/components/composed'
import { PaginationMoreButton, Skeleton } from '@/components/ui'
import { useInfiniteJournalSearch } from '@/utils/hooks/journal/useInfiniteJournalSearch'
import { JournalSearchListCard } from './components/JournalSearchListCard/JournalSearchListCard'
import { JournalSearchListEmpty } from './components/JournalSearchListEmpty/JournalSearchListEmpty'
import { SKELETONS } from './constants'
import type { IJournalBySearchProps } from './types'
import './styles.scss'

const JournalBySearch: FC<IJournalBySearchProps> = props => {
  const { searchText } = props

  const { searchListData, isError, isFetching, isLoading, hasNextPage, getNextPage } = useInfiniteJournalSearch({ searchText })

  const isListEmpty = !searchListData?.length

  return (
    <>
      <RubricsMenu />
      <JournalSearchInput />

      <div className="journalSearch page-wrapper">
        <Skeleton skeletons={SKELETONS} isLoading={isLoading}>
          {(isError || isListEmpty) && <JournalSearchListEmpty />}

          {searchListData && searchListData.map(item => <JournalSearchListCard key={item.id} itemData={item} />)}

          <PaginationMoreButton
            className="journalSearch__loadMoreBtn"
            isLoading={isFetching}
            onClick={getNextPage}
            hasNextPage={hasNextPage}
          />
        </Skeleton>
      </div>
    </>
  )
}

export default JournalBySearch
